import { Divider } from "@mantine/core";

export const dividerComponentSettings = Divider.extend({
  defaultProps: {
    color: "gray.3",
  },
});
